import { gql } from 'graphql-tag';

export const GET_ADMIN_TOPICS = gql`
  query GetLearningHubAdminTopics($mode: LearningHubMode) {
    getLearningHubAdminTopics(mode: $mode) {
      id
      name
      slug
      description
      mode
      icon
      sort_order
      is_active
      video_count
    }
  }
`;

export const GET_ADMIN_VIDEOS = gql`
  query GetLearningHubAdminVideos($input: GetLearningHubAdminVideosInput!) {
    getLearningHubAdminVideos(input: $input) {
      count
      results {
        id
        topic_id
        topic {
          id
          name
          slug
          icon
        }
        mode
        title
        description
        vimeo_id
        duration_label
        status
        is_new
        is_featured
        help_link
        sort_order
        published_at
        created_at
        updated_at
      }
    }
  }
`;

export const GET_ADMIN_VIDEO = gql`
  query GetLearningHubVideo($id: Int!) {
    getLearningHubVideo(id: $id) {
      id
      topic_id
      topic {
        id
        name
        slug
        icon
      }
      mode
      title
      description
      vimeo_id
      duration_label
      status
      is_new
      is_featured
      help_link
      sort_order
    }
  }
`;

export const GET_ADMIN_SETTINGS = gql`
  query GetLearningHubSettings {
    getLearningHubSettings {
      id
      help_base_url
      show_new_badge_days
      max_featured_videos
    }
  }
`;
